import React from 'react';

export const CommitteeAboutSection: React.FC = () => {
  return (
    <section id="section-committee-about" className="py-12 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="bg-white rounded-2xl shadow-sm p-6 md:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            {/* 제목과 첫 번째 본문 */}
            <div>
              <h2 className="text-2xl font-bold leading-relaxed mb-6">위원회 소개</h2>
              <p className="text-base leading-loose mb-6">
                사업성분석위원회는 대청마을 북측구역의 발전 방향을 함께 고민하는 자생적 모임입니다.<br />
                우리 위원회는 상가, 단독, 공동주택, 다세대 등 모든 소유주가 참여하여<br />
                객관적이고 합리적인 사업 분석을 통해 모아타운의 최적 추진 방안을 마련하고 있습니다.
              </p>
              
              <h3 className="text-lg font-semibold mb-3">목표는 명확합니다.</h3>
              <p className="text-base leading-loose mb-6">
                대청마을의 환경과 가치를 높이는 방향으로<br />
                모든 소유주가 공감할 수 있는 관리계획 수립과 개발방안을 마련하는 것입니다.
              </p>
            </div>

            {/* 나머지 내용 */}
            <div>
              <h3 className="text-lg font-semibold mb-3 mt-6 lg:mt-0">우리의 약속</h3>
              <p className="text-base leading-loose mb-6">
                대청마을 북측구역은 단순한 재개발이 아니라<br />
                함께 사는 미래를 위한 '공동체 도시 혁신 모델'입니다.<br />
                주민의 뜻과 전문가의 분석이 만나<br />
                서울이 주목하는 새로운 주거 기준을 만들어갑니다.
              </p>

              <h3 className="text-lg font-semibold mb-3">주요 활동</h3>
              <ul className="list-disc list-inside mb-6 space-y-2">
                <li className="text-base leading-loose">
                  서울시의회·국회의사당·SH공사·강남구청 등<br />
                  공공기관과의 협의 및 전문가 자문을 통해<br />
                  투명하고 현실적인 사업성 검토를 지속적으로 진행하고 있습니다.
                </li>
              </ul>

              <h3 className="text-lg font-semibold mb-3">마무리 문구</h3>
              <p className="text-base leading-loose">
                함께 만드는 변화, 함께 누리는 가치.<br />
                대청마을 모아타운은 당신의 참여로 완성됩니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};